export const getFormatter = (formatterName) => {
    if (window.SKUFormatters && window.SKUFormatters.hasOwnProperty(formatterName)) {
        return window.SKUFormatters[formatterName]
    }
    console.error("Could not load formatter with name " + formatterName)
}
